






























import { Component, Vue, Prop } from 'vue-property-decorator'
import { FourVolumeData, emptyFourVolume } from '@/api/heritageUnit/unitFour'
import { fileServer, thumbnailServer } from '@/api/common/upload'
import { chkFileExt, newGuid } from '@/configs/functions'
import { AttachInfo, openFile } from '@/api/common/attach'
import ElementUI from 'element-ui'
import { imageFormat } from '@/configs/fileTypes'

@Component
export default class UnitFourVolumeView extends Vue {
  public name = 'UnitFourVolumeView'

  @Prop({ default: '300px' })
  public maxHeight!: String

  @Prop({ default: [] })
  public dataList!: FourVolumeData[]
  //由父级传入
  // public dataList: FourVolumeData[] = []
  public setData(data: FourVolumeData[]) {
    this.dataList = data
  }
  public fileClick(f: AttachInfo) {
    var fileUrl = fileServer(f.Id, f.TempGuid, f.Name)
    openFile(fileUrl, f.Name)
  }
  public getOrgFile(f: AttachInfo) {
    return fileServer(f.Id, f.TempGuid, f.Name)
  }
  public getFileUrl(f: AttachInfo) {
    return thumbnailServer(f.Id, f.TempGuid, f.Name)
  }
  public chkImage(f: AttachInfo) {
    return chkFileExt(f.Ext, imageFormat)
  }
  public chkPdf(f: AttachInfo) {
    return chkFileExt(f.Ext, '.pdf')
  }
  // dynamic component
  public $refs!: {
    refTable: ElementUI.Table
  }
  public mounted() {
  }
  public beforeDestroy() {
  }
}
